import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";

import assetURLs from 'constants/assetURLs';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { generateRegistrationOTP } from 'services/api/auth';
import { resetAuthFlags, setError } from 'slices/auth/reducer';
import { getErrorMessage } from 'utils/helpers';
import { register } from 'slices/auth/thunk';
import VerifyOTP from 'Components/auth/VerifyOTP';

const REGISTRATION_MODE = 'email';
const MOBILE_COUNTRY_CODE = '+91';
const INDIAN_MOBILE_REGEX = /^[6-9]\d{9}$/;

const formatMobileDigits = (value: string) => {
    const digits = value.replace(/\D/g, '');
    const withoutCountryCode = digits.startsWith('91') ? digits.slice(2) : digits;
    return withoutCountryCode.replace(/^0+/, '').slice(0, 10);
};

const Register = (props: any) => {

    const dispatch: AppDispatch = useDispatch();

    const [loader, setLoader] = useState<boolean>(false);
    const { error } = useSelector((state: RootState) => state.auth);

    const [otpSent, setOTPSent] = useState<boolean>(false);

    const [userInfo, setUserInfo] = useState<{ username: string, name: string, mobile: string }>({ username: '', name: '', mobile: '' });

    const sendOTP = async (userCredentials: { username: string }) => {
        try {
            dispatch(setError(null));
            setLoader(true);
            const status = await generateRegistrationOTP({ ...userCredentials, mode: REGISTRATION_MODE });
            if (status) {
                setOTPSent(true)
            }
        } catch (error) {
            console.log(error)
            dispatch(setError(getErrorMessage(error, 'Failed to send OTP')));
        } finally {
            setLoader(false);
        }
    }

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            name: '',
            email: '',
            mobile: '',
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter Your Name"),
            email: Yup.string().required("Please Enter Your Email").email("Please enter a valid Email Address"),
            mobile: Yup.string()
                .required("Please Enter Your Mobile Number")
                .matches(INDIAN_MOBILE_REGEX, "Please enter a valid 10-digit mobile number"),
        }),
        onSubmit: async (values) => {
            setUserInfo({ username: values.email, name: values.name, mobile: values.mobile });
            await sendOTP({ username: values.email });
        }
    });

    const handleVerification = async (otp: string) => {
        const response = await dispatch(register({
            username: userInfo.username,
            name: userInfo.name,
            mobile: userInfo.mobile,
            otp
        }))
        if (response.meta.requestStatus === 'fulfilled') {
            props.router.navigate('/');
        }
    }

    useEffect(() => {
        dispatch(resetAuthFlags());
    }, [dispatch])

    document.title = "Sign Up |  Influns - Where Your Influence Matters";
    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4 text-white-50">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={assetURLs.LOGO_WHITE} alt="" height="50" />
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {
                            !otpSent ? (
                                <Row className="justify-content-center h-100">
                                    <Col md={8} lg={6} xl={5}>
                                        <Card className="mt-4">
                                            <CardBody className="p-4">
                                                <div className="text-center mt-2">
                                                    <h5 className="text-primary">Create a Manager Account</h5>
                                                    <p className="text-muted">Sign up to get started with Influns.</p>
                                                </div>
                                                {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                                                <div className="p-2 mt-4">
                                                    <Form
                                                        onSubmit={(e) => {
                                                            e.preventDefault();
                                                            validation.handleSubmit();
                                                            return false;
                                                        }}
                                                        action="#">

                                                        <div className="mb-3">
                                                            <Label htmlFor="name" className="form-label">Name</Label>
                                                            <Input
                                                                name="name"
                                                                className="form-control"
                                                                placeholder="Enter your name"
                                                                type="text"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.name || ""}
                                                                invalid={
                                                                    validation.touched.name && validation.errors.name ? true : false
                                                                }
                                                            />
                                                            {validation.touched.name && validation.errors.name ? (
                                                                <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                                            ) : null}
                                                        </div>

                                                        <div className="mb-3">
                                                            <Label htmlFor="email" className="form-label">Email</Label>
                                                            <Input
                                                                name="email"
                                                                className="form-control"
                                                                placeholder="Enter email"
                                                                type="email"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.email || ""}
                                                                invalid={
                                                                    validation.touched.email && validation.errors.email ? true : false
                                                                }
                                                            />
                                                            {validation.touched.email && validation.errors.email ? (
                                                                <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                            ) : null}
                                                        </div>

                                                        <div className="mb-3">
                                                            <Label htmlFor="mobile" className="form-label">Mobile Number</Label>
                                                            <div className="input-group">
                                                                <span className="input-group-text">{MOBILE_COUNTRY_CODE}</span>
                                                                <Input
                                                                    id="mobile"
                                                                    name="mobile"
                                                                    className="form-control"
                                                                    placeholder="Enter 10 digit mobile number"
                                                                    type="tel"
                                                                    inputMode="numeric"
                                                                    autoComplete="tel-national"
                                                                    maxLength={10}
                                                                    onChange={(e) => {
                                                                        validation.setFieldValue('mobile', formatMobileDigits(e.target.value));
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    value={validation.values.mobile || ""}
                                                                    invalid={
                                                                        validation.touched.mobile && validation.errors.mobile ? true : false
                                                                    }
                                                                />
                                                            </div>
                                                            {validation.touched.mobile && validation.errors.mobile ? (
                                                                <div className="invalid-feedback d-block">{validation.errors.mobile}</div>
                                                            ) : null}
                                                        </div>

                                                        <div className="mt-4">
                                                            <Button
                                                                disabled={loader}
                                                                className="primary-gradient w-100" type="submit">
                                                                {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}
                                                                Generate OTP
                                                            </Button>
                                                        </div>

                                                        <div className="mt-4 text-center">
                                                            <p className="mb-0">Already have an account? <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Sign In </Link></p>
                                                        </div>

                                                    </Form>
                                                </div>
                                            </CardBody>
                                        </Card>

                                    </Col>
                                </Row>
                            ) :
                                (
                                    <VerifyOTP
                                        username={userInfo.username}
                                        changeEmail={() => setOTPSent(false)}
                                        resendOTP={async () => {
                                            return await generateRegistrationOTP({ username: userInfo.username, mode: REGISTRATION_MODE });
                                        }}
                                        submitButtonText='Sign Up'
                                        handleVerification={handleVerification}
                                    />
                                )
                        }


                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Register);
